/**
 * Crestron console commands used to download and load a program package. Shared by the
 * package console-command dialog and the public package-link page so both render the
 * exact same commands.
 */
export const MIN_PROGRAM_SLOT = 1;
export const MAX_PROGRAM_SLOT = 99;

export function clampProgramSlot(slot: number | null | undefined): number {
    const value = Number.isFinite(slot) ? Math.trunc(slot as number) : MIN_PROGRAM_SLOT;
    return Math.max(MIN_PROGRAM_SLOT, Math.min(MAX_PROGRAM_SLOT, value || MIN_PROGRAM_SLOT));
}

/** Destination path on the processor for the selected program slot. */
export function programPath(slot: number): string {
    return `/simpl/app${String(clampProgramSlot(slot)).padStart(2, '0')}/program.cpz`;
}

/** Downloads the package straight from storage — fgetfile does not follow redirects, so the URL must be the final one. */
export function fgetfileCommand(downloadUrl: string | null | undefined, slot: number): string {
    if (!downloadUrl) return '';
    return `fgetfile --secure ${downloadUrl} ${programPath(slot)}`;
}

/** Loads the downloaded program into the selected slot. */
export function progloadCommand(slot: number): string {
    return `progload -p${clampProgramSlot(slot)}`;
}
